module.exports = __webpack_public_path__ + "img/developing-our-plan-mobile.ebc6d2d3.jpg";